import { render } from "./CloseModalButton.vue?vue&type=template&id=ddacb4f0&scoped=true"
import script from "./CloseModalButton.vue?vue&type=script&lang=js"
export * from "./CloseModalButton.vue?vue&type=script&lang=js"

import "./CloseModalButton.vue?vue&type=style&index=0&id=ddacb4f0&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddacb4f0"]])

export default __exports__